export const socialsData = {
    github: 'https://github.com/Akshithachinthakindi',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/akshithachinthakindi/',
    instagram: 'https://www.instagram.com/akshitha.chinthakindi/',
    // codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/akshitha0123',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}